import { put, delay, takeLatest, select } from "@redux-saga/core/effects";
import { approveVisitorParking, createVisitorParking, fetchAllVisitorsParking, fetchVisitorParkingById, statusUpdateVisitorParking, updateVisitorParking } from "../../../Utils/BackendAPICalls";
import { Actions, Types } from "../../Reducer/rootReducer";
import { VisitorParkingRequest, VisitorParkingRequestStatus } from "../../../Types/UnitFeatureTypes";

interface FetchVisitorParkingAction {
    payload: {
        id?: string;
        offset?: number;
        sortColumn?: string;
        sortDirection?: string;
    };
}

interface CreateVisitorParking {
    payload: {
        visitorParkingData: VisitorParkingRequest;
    };
}

interface ApproveVisitorParkingAction {
    payload: {
        approval_date: Date;
        approved_by: number;
        id: number;
    };
}

interface StatusUpdateVisitorParkingAction {
    payload: {
        id: number;
        status: VisitorParkingRequestStatus;
    };
}

export function* fetchVisitorParkingRequestFunction(action: FetchVisitorParkingAction): Generator<any, void, Response> {
    const { id, offset, sortColumn, sortDirection } = action.payload;
    let response: any = null;
    try {
        yield delay(100);
        if (id) {
            response = yield fetchVisitorParkingById(id);
        } else {
            response = yield fetchAllVisitorsParking(offset ?? 0, sortColumn ?? 'created_on', sortDirection ?? 'desc');
        }
        if (!response || response?.error) {
            yield put(Actions.fetchVisitorParking.visitorParkingActions.failure({ message: response.error }));
        }
        yield put(Actions.fetchVisitorParking.visitorParkingActions.success({
            visitorParking: response.visitorParking,
            visitorParkings: response.visitorParkings,
            count: response.count
        }));
    } catch (err) {
        const error = { message: "fatalFailure" };
        yield put(Actions.fetchVisitorParking.visitorParkingActions.failure(error));
    }
}

export function* createVisitorParkingRequestFunction(action: CreateVisitorParking): Generator<any, void, Response> {
    const { visitorParkingData } = action.payload;
    try {
        yield delay(100);
        const response: any = yield createVisitorParking(visitorParkingData);
        if (!response || response?.error) {
            yield put(Actions.visitorParking.createVisitorParkingRequestAction.failure({ message: response.error }));
        }
        yield put(Actions.visitorParking.createVisitorParkingRequestAction.success({ id: response.id }));
    } catch (err) {
        const error = { message: "fatalFailure" };
        yield put(Actions.visitorParking.createVisitorParkingRequestAction.failure(error));
    }
}

export function* updateVisitorParkingRequestFunction(action: CreateVisitorParking): Generator<any, void, Response> {
    const { visitorParkingData } = action.payload;
    try {
        yield delay(100);
        const response: any = yield updateVisitorParking(visitorParkingData);
        if (!response || response?.error) {
            yield put(Actions.visitorParking.updateVisitorParkingRequestAction.failure({ message: response.error }));
        } else {
            yield put(Actions.visitorParking.updateVisitorParkingRequestAction.success());
        }
    } catch (err) {
        const error = { message: "fatalFailure" };
        yield put(Actions.visitorParking.updateVisitorParkingRequestAction.failure(error));
    }
}

export function* approveVisitorParkingRequestFunction(action: ApproveVisitorParkingAction): Generator<any, void, Response> {
    const { approval_date, approved_by, id } = action.payload;
    try {
        yield delay(100);
        const response: any = yield approveVisitorParking({
            approval_date,
            approved_by,
            id
        });
        if (!response || response?.error) {
            yield put(Actions.visitorParking.approveVisitorParkingRequestAction.failure({ message: response.error }));
        } else {
            yield put(Actions.visitorParking.approveVisitorParkingRequestAction.success());
        }
    } catch (err) {
        const error = { message: "fatalFailure" };
        yield put(Actions.visitorParking.statusUpdateVisitorParkingRequestAction.failure(error));
    }
}

export function* statusUpdateVisitorParkingRequestFunction(action: StatusUpdateVisitorParkingAction): Generator<any, void, Response> {
    const { id, status } = action.payload;
    try {
        yield delay(100);
        const response: any = yield statusUpdateVisitorParking(id, status);
        if (!response || response?.error) {
            yield put(Actions.visitorParking.statusUpdateVisitorParkingRequestAction.failure({ message: response.error }));
        } else {
            yield put(Actions.visitorParking.statusUpdateVisitorParkingRequestAction.success());
        }
    } catch (err) {
        const error = { message: "fatalFailure" };
        yield put(Actions.visitorParking.statusUpdateVisitorParkingRequestAction.failure(error));
    }
}

export default function* visitorParkingSaga() {
    yield takeLatest(Types.FETCH_VISITOR_PARKING_REQUEST, fetchVisitorParkingRequestFunction);
    yield takeLatest(Types.CREATE_VISITOR_PARKING_REQUEST, createVisitorParkingRequestFunction);
    yield takeLatest(Types.UPDATE_VISITOR_PARKING_REQUEST, updateVisitorParkingRequestFunction);
    yield takeLatest(Types.APPROVE_VISITOR_PARKING_REQUEST, approveVisitorParkingRequestFunction)
    yield takeLatest(Types.STATUS_UPDATE_VISITOR_PARKING_REQUEST, statusUpdateVisitorParkingRequestFunction);
}
